
import dev.zacsweers.metro.DependencyGraph
import dev.zacsweers.metrox.viewmodel.ViewModelGraph
import com.bikompanion.domain.AnonymousIdentityProvider
import com.bikompanion.domain.di.AppScope

@DependencyGraph(AppScope::class)
interface AppGraph : ViewModelGraph {
    val anonymousIdentity: AnonymousIdentityProvider
}
